import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import TableShowMemberShipUser from './TableShowMemberShipUser';

import { DatePicker, Select } from 'antd';
import moment from 'moment';
// const { RangePicker } = DatePicker;

const dataReport =  [
		{
			"id": "68bfeaeaaadacf1a67ed17e5",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-09-09T08:52:58.488Z",
			"branch": "header.dt",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68be52b8aadacf1a67ecfee9",
			"userId": "6699f48cd89d346448f49ad3",
			"date": "2025-09-08T03:51:20.086Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b1750caadacf1a67ec9d4c",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T09:38:20.241Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b17465aadacf1a67ec9cdf",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T09:35:33.147Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b17157aadacf1a67ec8f76",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T09:22:31.625Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b170c3aadacf1a67ec8e15",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T09:20:03.161Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b16e1caadacf1a67ec8b5a",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T09:08:44.952Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b16068ec712773211f4fd5",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T08:10:16.615Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b15facec712773211f4fcc",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T08:07:08.055Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b13dbb7531b551706bb301",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T05:42:19.986Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b13c58b958f05010652b82",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T05:36:24.859Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b13c4c4c7b650a1c396c06",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T05:36:12.279Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b13c3fe0b7b757e800980c",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T05:35:59.221Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b125ac56a8c805601f3350",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T03:59:40.149Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "68b1251756a8c805601f3349",
			"userId": "680c84892ed49626c448af02",
			"date": "2025-08-29T03:57:11.060Z",
			"branch": "Thai Van Lung 2",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "67f88ec50b937a6b06b014aa",
			"userId": "67aebd55b5616122b5ecf995",
			"date": "2025-04-11T03:38:45.696Z",
			"branch": "azhbt1",
			"membership": "E01",
			"voucherName": "THIS IS A TEST COUPON",
			"voucherCode": "TESTCOUPON"
		},
		{
			"id": "678a2addedec48edc9d8c2ff",
			"userId": "669a1dcedd88f4717b5bfaf3",
			"date": "2025-01-17T10:03:09.163Z",
			"branch": "Kim Ma 3",
			"membership": "E01",
			"voucherName": "Hello Admin",
			"voucherCode": "ADMIN888"
		}
	]

const VoucherMemberShip = () => {
    const [voucherData, setVoucherData] = useState(dataReport);
    const [loading, setLoading] = useState(false);
    const [dateRange, setDateRange] = useState("");

    const auth = useSelector(state => state.auth);
    const token = useSelector(state => state.token);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    // const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

    const handleYearChange = (direction) => {
        const newYear = selectedYear + (direction === 'prev' ? -1 : 1);
        setSelectedYear(newYear);
        loadVoucherData(newYear);
    };

    const loadVoucherData = async (year, month) => {
        try {
            setLoading(true);
            // const startDate = moment([year, month]).startOf('month');
            // const endDate = moment([year, month]).endOf('month');
            
            // const response = await axios.get(
            //     `/api/membership/vouchers?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`,
            //     {
            //         headers: { Authorization: token }
            //     }
            // );

            // setVoucherData(response.data.data);
        } catch (error) {
            console.error('Error fetching voucher data:', error);
        } finally {
            setLoading(false);
        }
    };


    const fetchVoucherData = async () => {
        try {
            setLoading(true);
            const [startDate, endDate] = dateRange;
            
            const response = await axios.get(
                `/api/membership/vouchers?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`,
                {
                    headers: { Authorization: token }
                }
            );

            setVoucherData(response.data.data);
        } catch (error) {
            console.error('Error fetching voucher data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            loadVoucherData(selectedYear);
        }
    }, [selectedYear, token]);

    function test() {

    }

    return (
        <div className="voucher-membership-container" style={{ padding: '20px' }}>
            <h1 style={{margin:"center", width:"100%"}}>Use Voucher Membership</h1>

            <div className="date-navigation" style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <button 
                    className="year-nav-btn btn-primary" 
                    onClick={() => handleYearChange('prev')}
                    style={{ padding: '4px 8px' }}
                >
                    « {selectedYear - 1}
                </button>
                
                <DatePicker.YearPicker 
                    value={moment([selectedYear])}
                    onChange={(date) => {
                        if (date) {
                            setSelectedYear(date.year());
                            // setSelectedMonth(date.month());
                        }
                    }}
                    format="MMMM YYYY"
                    allowClear={false}
                />
                
                <button 
                    className="year-nav-btn btn btn-primary" 
                    onClick={() => handleYearChange('next')}
                    style={{ padding: '4px 8px' }}
                >
                    {selectedYear + 1} »
                </button>
            </div>

            {
                voucherData.length > 0 &&
                 <div className='manager-user-content rp manager-user_branch'>
                    <TableShowMemberShipUser 
                        typeShow={"voucherUser"}
                        data = {voucherData}
                        function1={()=>test()}
                        function2={()=>test()}
                        function3={()=>test()}
                    />
                 </div>
            }
        </div>
    );
};

export default VoucherMemberShip;